exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1XYB{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_1XYB",
	"root": "_1XYB"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/Navigation/Navigation.css
// module id = 175
// module chunks = 0